if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('.announcement-bar__close');
      this.countdowns = this.querySelectorAll('[data-countdown]');
      this.sectionId = this.dataset.sectionId;
      this.storageKey = `announcement-bar-dismissed-${this.sectionId}`;

      this.handleClose = this.handleClose.bind(this);
      this.updateCountdowns = this.updateCountdowns.bind(this);
    }

    connectedCallback() {
      if (this.isDismissed()) {
        this.hide();
        return;
      }

      this.closeButton?.addEventListener('click', this.handleClose);
      this.initLocalizationSelectors();

      if (this.countdowns.length > 0) {
        this.initCountdowns();
        this.countdownInterval = setInterval(this.updateCountdowns, 1000);
      }
    }

    disconnectedCallback() {
      this.closeButton?.removeEventListener('click', this.handleClose);
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }

    isDismissed() {
      try {
        return sessionStorage.getItem(this.storageKey) === 'true';
      } catch (e) {
        return false;
      }
    }

    handleClose() {
      try {
        sessionStorage.setItem(this.storageKey, 'true');
      } catch (e) {
        console.warn('Could not save dismissal state');
      }
      this.hide();
    }

    hide() {
      this.style.display = 'none';
      // Also hide the section wrapper to prevent empty space
      const sectionWrapper = this.closest('.shopify-section');
      if (sectionWrapper) {
        sectionWrapper.style.display = 'none';
      }
    }

    initCountdowns() {
      this.countdowns.forEach(countdown => {
        const endDateStr = countdown.dataset.endDate;
        if (!endDateStr) return;

        const endDate = new Date(endDateStr);
        if (isNaN(endDate.getTime())) {
          this.showExpiredMessage(countdown);
          return;
        }

        countdown.endDate = endDate;
        this.updateCountdown(countdown);
      });
    }

    updateCountdowns() {
      this.countdowns.forEach(countdown => {
        if (countdown.endDate) {
          this.updateCountdown(countdown);
        }
      });
    }

    updateCountdown(countdown) {
      const now = new Date();
      const timeLeft = countdown.endDate - now;

      if (timeLeft <= 0) {
        this.showExpiredMessage(countdown);
        return;
      }

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      const timerElement = countdown.querySelector('.announcement-bar__countdown-timer');
      if (!timerElement) return;

      let timeString = '';
      if (days > 0) {
        timeString = `${days}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      } else {
        timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }

      timerElement.textContent = timeString;
    }

    initLocalizationSelectors() {
      this.querySelectorAll('.announcement-bar__selector select').forEach((select) => {
        select.addEventListener('change', () => {
          select.closest('form')?.submit();
        });
      });
    }

    showExpiredMessage(countdown) {
      const expiredMessage = countdown.dataset.expiredMessage;
      if (!expiredMessage) {
        countdown.style.display = 'none';
        return;
      }

      const contentElement = countdown.querySelector('.announcement-bar__countdown-content');
      if (contentElement) {
        const link = contentElement.closest('a');
        if (link) {
          link.textContent = expiredMessage;
        } else {
          contentElement.textContent = expiredMessage;
        }
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
